import '../../App.css';
import '../../Css/Description.css';
import '../../Css/Team.css'
import data from '../../JsonFiles/Equipe.json';

export default function EquipeDescription(props) {

  return (
      <div>
          <div className="team-section section-border-top">
            <div className='team-title-section'>
              {/* <div className='img-team-container section-border-bottom'><img className='img-team'  src='./images/photos/DreamTeam.png'></img>
              </div> */}
              <div className='title'>
                <div className='section-title'>{props.title}</div> 
                <div className='big-line'><div className='horizontalLine'></div></div>
              </div>
            </div>
            <div className=" team-text-container text">Chez Astraya, nous sommes deux profils complémentaires réunis par une même conviction : la technologie doit être accessible à tous.
              <p>Ensemble, nous partageons des valeurs simples mais essentielles : l'écoute, parce que chaque projet commence par une relation de confiance. L'équité, parce que nous croyons à des solutions accessibles et adaptées à chacun, 
                sans jamais sacrifier la qualité. La transparence, parce que nos clients méritent une communication claire et honnête, à chaque étape de notre collaboration. </p>
              <p>Nous n'utilisons aucune intelligence artificielle dans la réalisation de nos prestations : chaque projet est pensé, conçu et réalisé en mettant à profit nos compétences, avec toute l'expertise et l'attention humaine qu'il mérite.</p>
              <p>Curieuses et exigeantes, nous restons en veille constante sur les évolutions de nos secteurs afin de toujours vous proposer ce qui se fait de mieux.</p>
            </div>
          </div>
      </div>
    );
  }